import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-243948ab"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "filter-list-content"
};
const _hoisted_3 = {
  class: "input-select-content"
};
const _hoisted_4 = {
  class: "filter-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "账号", -1));
const _hoisted_6 = {
  class: "btn-content"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'NewAccountFilterBlock',
  emits: ['filterSubmit'],
  setup(__props, {
    emit
  }) {
    const accountName = ref('');
    const filterSubmit = () => {
      let params = {
        accountName: accountName.value
      };
      emit('filterSubmit', params);
    };
    const init = () => {
      accountName.value = '';
      filterSubmit();
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_input, {
        placeholder: "输入账号简称搜索",
        value: accountName.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => accountName.value = $event),
        valueModifiers: {
          trim: true
        }
      }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_button, {
        onClick: init
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});